module.exports = __webpack_public_path__ + "static/media/12.da0c06b1.jpeg";